import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  makeStyles,
  MenuItem,
  Grid,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useAlert } from "react-alert";
import { createPrivateSale } from "../../../adminModel/privateSale";
import { getCategory } from "../../../adminModel/group"; // Inalis ang getGroup dahil hindi gamit
import Color from "../../../utils/colors";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTypography-h5": {
      color: Color.green,
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  avatar: {
    height: 100,
    width: 100,
  },
}));

const Create = ({ className, ...rest }) => {
  const classes = useStyles();
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  var { id } = useParams();

  const [category, setCategory] = useState([]);
  
  const fetchCategory = useCallback(async (search) => {
    setLoading(true);
    async function getAuction() {
      const results = await getCategory(search);
      setLoading(false);
      setCategory(results);
    }
    getAuction().catch(console.error);
  }, []);

  useEffect(() => {
    fetchCategory();
  }, [fetchCategory]);

  const [values, setValues] = useState({
    privateSalesGroup: "EXHIBITION",
    artist: "",
    signed_dated: "",
    medium: "",
    size: "",
    title: "",
    property: "",
    coa: "",
    provenance: "",
    exhibited: "",
    literature: "",
    write_up: "",
    lot_group: "",
    lot_details_html: "",
    alias: "",
  });

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const PrivateSaleData = {
      privateSalesGroup: values.privateSalesGroup,
      exhibit_id: id,
      artist: values.artist,
      title: values.title,
      signed_dated: values.signed_dated,
      medium: values.medium,
      size: values.size,
      property: values.property,
      coa: values.coa,
      provenance: values.provenance,
      exhibited: values.exhibited,
      literature: values.literature,
      write_up: values.write_up,
      lot_group: values.lot_group,
      lot_details_html: values.lot_details_html,
      alias: values.alias,
    };

    try {
      const result = await createPrivateSale(PrivateSaleData);
      setLoading(false);
      if (result.success !== false) {
        alert.success(result.msg || "Saved successfully");
      } else {
        alert.error(result.msg || "Failed to save");
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
      alert.error("An error occurred");
    }
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <form
            onSubmit={handleFormSubmit}
            autoComplete="off"
            className={clsx(classes.root, className)}
            {...rest}
          >
            <Card>
              <CardHeader title="Data Entry" />
              <Divider />
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item md={6}>
                    <TextField
                      fullWidth
                      label="Artist"
                      margin="normal"
                      name="artist"
                      value={values.artist}
                      type="text"
                      variant="outlined"
                      onChange={handleChange}
                    />
                    <TextField
                      margin="normal"
                      fullWidth
                      label="Title"
                      name="title"
                      value={values.title}
                      type="text"
                      variant="outlined"
                      onChange={handleChange}
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      label="Medium"
                      name="medium"
                      type="text"
                      value={values.medium}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      fullWidth
                      margin="normal"
                      label="Signed Dated"
                      name="signed_dated"
                      type="text"
                      value={values.signed_dated}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      label="Category"
                      name="lot_group"
                      value={values.lot_group}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      select
                      variant="outlined"
                    >
                      {category.map((val, i) => (
                        <MenuItem key={i} value={val.categories}>
                          {val.categories}
                        </MenuItem>
                      ))}
                    </TextField>

                    <TextField
                      margin="normal"
                      fullWidth
                      label="Size"
                      name="size"
                      multiline
                      rows={4}
                      value={values.size}
                      type="text"
                      variant="outlined"
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      margin="normal"
                      fullWidth
                      label="Property"
                      name="property"
                      value={values.property}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      multiline
                      minRows={4}
                      label="Coa"
                      name="coa"
                      value={values.coa}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      multiline
                      minRows={4}
                      label="Exhibited"
                      name="exhibited"
                      value={values.exhibited}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      label="Alias"
                      multiline
                      minRows={4}
                      name="alias"
                      value={values.alias}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      multiline
                      minRows={4}
                      label="Provenance"
                      name="provenance"
                      value={values.provenance}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      multiline
                      minRows={4}
                      label="Literature"
                      name="literature"
                      value={values.literature}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      multiline
                      minRows={4}
                      label="Lot Details HTML"
                      name="lot_details_html"
                      value={values.lot_details_html}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />

                    <TextField
                      margin="normal"
                      fullWidth
                      label="Write up"
                      name="write_up"
                      multiline
                      minRows={4}
                      value={values.write_up}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <Box display="flex" justifyContent="flex-end" p={2}>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                >
                  Save Details
                </Button>
              </Box>
            </Card>
          </form>
        </Grid>
      </Grid>

      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

Create.propTypes = {
  className: PropTypes.string,
};

export default Create;